import React from "react";
import { PathwayFormGroup, PathwayLabel } from "../../StyledComponents/PathwayForm";
import { Input, Label } from "reactstrap";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import usePathwayInputGroup from "../../../_hooks/usePathwayInputGroup";
import MandatoryStar from "../MandatoryStar";
import { PathwayTooltip } from "../PathwayTooltip";

const PathwaySelectInputGroup = (props) => {
    const { valid, blurredAfterInvalid, mandatory, isNotFilled, handleChange, onBlur, inputRef } = usePathwayInputGroup(
        props.name,
        props.value,
        props.needsToBeFilled,
        props.submitted,
        props.autoFocus,
        props.triggerOnBlur,
        props.inputValidation,
        props.handleChange
    );

    return (
        <PathwayFormGroup data-cy={props.dataCy ? props.dataCy + "-form" : undefined}>
            {(props.label || props.tooltip) && (
                <TooltipInputGroup>
                    <LabelWrapper>
                        <LabelParagraph
                            data-cy={props.dataCy ? props.dataCy + "-label" : undefined}
                            strong={props.strongLabel}
                        >
                            {props.label}
                        </LabelParagraph>{" "}
                        {mandatory && <MandatoryStar />}
                    </LabelWrapper>
                    {props.tooltip && (
                        <PathwayTooltip id={props.dataCy + "-tooltip"} iconSize="var(--iconSize-xs)">
                            {props.tooltip}
                        </PathwayTooltip>
                    )}
                </TooltipInputGroup>
            )}

            {blurredAfterInvalid ? (
                <Input
                    type="select"
                    name={props.name}
                    data-cy={props.dataCy}
                    value={props.value || ""}
                    disabled={props.disabled}
                    onChange={(e) => handleChange(e)}
                    onBlur={onBlur}
                    valid={valid}
                    invalid={!valid}
                >
                    {props.showNullOption && (
                        <option value="">{props.nullOptionValue ? props.nullOptionValue : "-"}</option>
                    )}
                    {props.children}
                </Input>
            ) : (
                <Input
                    type="select"
                    name={props.name}
                    data-cy={props.dataCy}
                    value={props.value || ""}
                    disabled={props.disabled}
                    onChange={(e) => handleChange(e)}
                    onBlur={onBlur}
                    innerRef={inputRef}
                    invalid={!valid}
                >
                    {props.showNullOption && (
                        <option value="">{props.nullOptionValue ? props.nullOptionValue : "-"}</option>
                    )}
                    {props.children}
                </Input>
            )}
            {mandatory && isNotFilled && props.invalidInputMessage && !props.inputValidation ? (
                <InvalidLabel>{props.invalidInputMessage}</InvalidLabel>
            ) : mandatory && isNotFilled ? (
                <InvalidLabel>Eine Auswahl wird benötigt.</InvalidLabel>
            ) : (
                !valid && <InvalidLabel>{props.invalidInputMessage}</InvalidLabel>
            )}
        </PathwayFormGroup>
    );
};

export default PathwaySelectInputGroup;

PathwaySelectInputGroup.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleChange: PropTypes.func.isRequired,
    dataCy: PropTypes.string,
    invalidInputMessage: PropTypes.string,
    needsToBeFilled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    inputValidation: PropTypes.func,
    triggerOnBlur: PropTypes.func,
    showNullOption: PropTypes.bool,
};

const InvalidLabel = styled(Label)`
    position: absolute;
    color: var(--danger);
    font-size: 0.75rem;
    bottom: -1.25rem;
`;

export const LabelWrapper = styled(PathwayLabel)`
    display: grid;
    grid-template-columns: auto min-content;
`;

export const LabelParagraph = styled.p`
    ${(props) =>
        props.strong &&
        css`
            font-weight: bolder;
        `}
    margin: 0;
`;

const TooltipInputGroup = styled.div`
    display: grid;
    grid-template-columns: max-content min-content;
    column-gap: var(--gap-s);
`;
